import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-6 mt-16">
      <div className="bg-white shadow-lg rounded-lg w-5/6 max-w-6xl p-10">
        <h1 className="text-4xl font-bold text-center text-gray-800 mb-6">Terms & Conditions</h1>
        <p className="text-gray-600 text-center mb-8">
          <strong>Effective Date:</strong> 08-02-2025 | <strong>Last Updated:</strong> 08-02-2025
        </p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-700 mb-3">1. General Terms</h2>
          <p className="text-gray-600">
            By using <strong>Himanshu Salary Corner</strong>, you agree to comply with all applicable regulations.
            Users must provide accurate information for correct results. We are <strong>not responsible</strong> or errors caused by incorrect inputs. you agree to comply with all applicable regulations of the Maharashtra Government.  
            Unauthorized <strong>modification, duplication, or misuse</strong> of this website is strictly prohibited.  
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-700 mb-3">2. Unauthorized Use & Restrictions</h2>
          <p className="text-gray-600">
            - Users are prohibited from using bots, scraping data, or attempting unauthorized access.  
            - Modifying, distributing, or disrupting website functionality is strictly forbidden.  
            - Violations may result in <strong>legal action and permanent restriction</strong>.  
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold text-gray-700 mb-3">3. Amendments</h2>
          <p className="text-gray-600">
            We reserve the right to <strong>update</strong> these terms at any time. Continued use of our services implies acceptance of the revised terms.
          </p>
        </section>

        <div className="text-center mt-6">
          <a href="/" className="text-blue-500 hover:underline text-lg">← Go Back</a>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
